import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select-v2'
import FutureDetailsRow from './FutureDetailsRow'
import FutureEarningsChart from './FutureEarningsChart'
import i18n from '../../../i18n'
import './FutureDetailsTable.css'
import { getEntityOptionFuture } from '../../../reducers/data'
import { setEntityFuture } from '../../../actions/data'
import moment from 'moment'

const logo = 'https://www.wisdomtree.com/investments/-/media/us-media-files/wisdomtree-tools/wt-wht-logo-tools.png'

const customStyles = {
  control: base => ({
    ...base,
    borderRadius: 0,
    boxShadow: 'none',
  }),
  option: provided => ({
    ...provided,
    color: '#050139',
    fontSize: 14,
    borderRadius: 0,
    border: '0px #8c959b',
    backgroundColor: 'white',
    ':hover': {
      backgroundColor: '#050139',
      color: 'white'
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    borderColor: '#8c959b'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'
    return { ...provided, opacity, transition }
  },
  dropdownIndicator: base => ({
    ...base,
    color: '#8c959b'
  }),
  multiValue: (base, state) => {
    return { ...base, display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '90%' };
  },
  multiValueLabel: (base, state) => {
    return { ...base, padding: 0, paddingRight: '6px', display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
  },
  multiValueRemove: (base, state) => {
    return { ...base, display: 'inline-block', marginLeft: '2px' };
  },
  valueContainer: (base, state) => {
    return { ...base, display: 'flex', flexWrap: 'nowrap' };
  },
}

class FutureDetailsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataType: 'chart', // default value
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedEntityOptionFuture !== this.props.selectedEntityOptionFuture) {
      this.forceUpdate(); // Force update if selected entities change
    }
  }

  renderReportingDate() {
    const { earningsAggs } = this.props
    let date = new Date(earningsAggs[0].cutStamp)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }

  formatDate(string) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(string).toLocaleDateString([], options)
  }

  renderEarningsHeader(earningsType) {
    const { earningsAggsFuture } = this.props
    let minDate = earningsAggsFuture[0].dt
    const formattedDate = moment(minDate, "YYYY/MM/DD").format("MM/DD/YYYY");

    return (
      <thead>
        <tr>
          <th colSpan={earningsType === 'growth-all' ? 5 : 5} className='tickerHeader'>
            {i18n.t('forward-earnings')}  {i18n.t('data')} {' '} As of {formattedDate}
            <img src={logo} className='tickerLogo' alt="" />
          </th>
        </tr>

        <tr>
          <th colSpan='1' className={'tableheading-textLeft'}>
            {i18n.t('Index').toUpperCase()}
          </th>
          <th colSpan='1' className={'tableheading-textCenter'}>
            {i18n.t('Year').toUpperCase()}
          </th>
          <th colSpan='1' className={'tableheading-textCenter'}>
            {i18n.t('operating-earnings').toUpperCase()}
          </th>
          <th colSpan='1' className={`${'borderleft'} ${'borderbottom'} ${'tableheading-textCenter'}`}>
            {i18n.t('Sales').toUpperCase()}
          </th>

          {/* <th colSpan='1' className={'tableheading-textCenter'}>
            {i18n.t('CashFlow').toUpperCase()}
          </th> */}
        </tr>
      </thead>
    )
  }


  renderEarningsRows() {
    const { earningsAggsFuture, selectedEntityOptionFuture } = this.props

    const tickers = selectedEntityOptionFuture.map(option => option.split(' - ')[0]);
    const filteredEarningsAggsFuture = earningsAggsFuture.filter(row => tickers.includes(row.ticker));

    if (filteredEarningsAggsFuture) {
      return filteredEarningsAggsFuture.map((fund, idx) => {
        return <FutureDetailsRow key={idx} data={fund} />
      })
    }
  }

  setDataType = (type) => {
    this.setState({ dataType: type });
  }

  render() {
    const { earningsTickerListingFuture, setEntityFuture, entityOptionFuture, earningsType, earningsAggsFuture, selectedEntityOptionFuture } = this.props
    const tickers = selectedEntityOptionFuture.map(option => option.split(' - ')[0]);
    const filteredEarningsAggsFuture = earningsAggsFuture.filter(row => tickers.includes(row.ticker));


    const sortedEntityOptionFuture = entityOptionFuture
      .map(option => option.split(' - '))
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(option => option.join(' - '));



    function arrayToFormOptions(values) {
      if (Array.isArray(values)) {
        return values.sort().map(item => ({ value: item, label: item }))
      } else {
        return [];
      }
    }

    function valueToFormValue(value) {
      if (value && value.length > 0) {
        return value.map(item => ({ value: item, label: item }))
      } else {
        return null
      }
    }

    if (earningsTickerListingFuture.length > 0) {
      return (
        <div>
          <div className='instructions'>Select up to ten indices to compare.</div>
          <div className='row'>
            <div className='col-md-10' style={{ textAlign: 'left', paddingRight: '3px' }}>
              <Select
                placeholder={i18n.t('Select Entity')}
                styles={customStyles}
                isMulti={true}
                onChange={setEntityFuture}
                closeMenuOnSelect={false}
                options={arrayToFormOptions(sortedEntityOptionFuture)}
                value={valueToFormValue(selectedEntityOptionFuture)}
              />
            </div>

            <div className='col-md-1' >
              <button onClick={() => setEntityFuture([])} type='button' className={`earnings-buttons-future-clear`}>
                {i18n.t('CLEAR')}
              </button>

            </div>
          </div>
          <div className='futureButtonContainer'>
            {selectedEntityOptionFuture && selectedEntityOptionFuture.length > 0 &&
              <div className='earnings-buttons-future'>
                <button onClick={() => this.setDataType('chart')} type='button' className={`earningsButtonFuture ${(this.state.dataType === 'chart' ? 'isselected' : 'notselected')}`}>
                  {i18n.t('CHART')}
                </button>
                <button onClick={() => this.setDataType('tableData')} type='button' className={`earningsButtonFuture ${(this.state.dataType === 'tableData' ? 'isselected' : 'notselected')}`}>
                  {i18n.t('DATA TABLE')}
                </button>
              </div>
            }
          </div>
          <div className={'forward-earnings-def'}>

            {i18n.t('forward-earnings-def')}


          </div>

          {this.state.dataType === 'chart' && (
            <div className='col-md-12 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
              <FutureEarningsChart type={'future'} filteredEarningsAggsFuture={filteredEarningsAggsFuture} />
            </div>
          )}

          {this.state.dataType === 'tableData' && (
            <div className='table-responsive'>
              <table className={'table table-earnings-future'}>
                {this.renderEarningsHeader(earningsType)}
                <tbody>{this.renderEarningsRows()}</tbody>
              </table>
            </div>
          )}

          <div className={'introCopy'}>
            <span style={{ textAlign: 'left', color: '#050139', fontSize: '10px', fontWeight: '400', marginTop: '5px', marginBottom: '5px' }}>
              {i18n.t('source')} fundamental metrics show calendar year growth rates for each respective metric (earnings, sales) relative to the prior year.

            </span>
          </div>
          {/* <div className={'introCopy'}>
            <span style={{ textAlign: 'left', color: '#050139', fontSize: '10px', fontWeight: '400', marginTop: '5px', marginBottom: '5px' }}>
              {i18n.t('cashflow')} : {i18n.t('cashflow-def')}

            </span>

          </div> */}

          <div className={'introCopy'}>
            <span style={{ textAlign: 'left', color: '#050139', fontSize: '10px', fontWeight: '400', marginTop: '5px', marginBottom: '5px' }}>
              {i18n.t('operating-earnings')} : {i18n.t('operating-earnings-def')}

            </span>

          </div>
        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    earningsType: state.data.earningsType,
    earningsTickerListingFuture: state.data.earningsTickerListingFuture,
    earningsAggsFuture: state.data.earningsAggsFuture,
    entityOptionFuture: getEntityOptionFuture(state),
    selectedEntityOptionFuture: state.data.selectedEntityOptionFuture,
    periodOptionFuture: state.data.periodOptionFuture,
    selectedPeriodOptionFuture: state.data.selectedPeriodOptionFuture,
    selectedRangeOptionFuture: state.data.selectedRangeOptionFuture,
    rangeOptionFuture: state.data.rangeOptionFuture,
    initialLoadFuture: true
  }
}

export default connect(mapStateToProps, {
  setEntityFuture,
})(FutureDetailsTable)



// WEBPACK FOOTER //
// ./src/components/App/FutureDetailsTable/FutureDetailsTable.js